module.exports = __webpack_public_path__ + "access-group-hq-icon.svg?6976a027a6a5bee109b0333c28430087";